// modal-session-expired.module.ts
import { NgModule } from '@angular/core';
import { ModalSessionExpiredComponent } from './session-expired.component';

@NgModule({
    imports: [ModalSessionExpiredComponent]
})
export class ModalSessionExpiredModule { }
